import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const ProgressBar = ({ bgcolor, completed, amount, name, srNo, id }) => {
  const [fillWidth, setFillWidth] = useState("0%");
  const navigate = useNavigate();
  useEffect(() => {
    const timeout = setTimeout(() => {
      setFillWidth(`${completed.toFixed(2)}%`);
    }, 100);
    return () => clearTimeout(timeout);
  }, [completed]);

  const containerStyles = {
    height: 10,
    width: "100%",
    backgroundColor: "#EBE8F7",
    borderRadius: 50,
    overflow: "hidden",
    marginTop: 6,
    marginBottom: 12,
  };

  const fillerStyles = {
    height: "100%",
    width: fillWidth,
    backgroundColor: bgcolor,
    borderRadius: "inherit",
    transition: "width 1.3s ease-in-out",
  };

  return (
    <div className="w-full">
      <div
        className="flex justify-between items-center"
        style={{
          fontSize: "12px",
          letterSpacing: "0.5px",
          marginBottom: "2px",
        }}
      >
        <div className="flex flex-row gap-2 dark:text-white">
          <span>{srNo}.</span>
          <span className="capitalize">{name}</span>
        </div>
        <span className="font-medium dark:text-white" >
          Rs.{Number(amount).toLocaleString("en-IN")}
        </span>
      </div>
      <div className="cursor-pointer" style={containerStyles} onClick={()=>navigate(`/admin/contracts/${id}`)}>
        <div style={fillerStyles}></div>
      </div>
    </div>
  );
};
